<template>
  <div class="bp-form-item"
       :class="[
       {'input-group': hasIcon},
       {'has-right-slot': addonRightIcon || this.$slots.addonRight},
       {'has-error': error},
       {'input-group-focus': focused},
       {'has-label': label || $slots.label},
       {'has-success': !error && touched && hadError},
       $attrs.class]"
       :style="$attrs.style">
    <slot name="label">
      <label v-if="label" class="bp-form-label" :class="labelClasses">
        {{label}}
        <span v-if="required" style="color: red">*</span>
        <a class="btn-link se-help-icon " v-tooltip.top="'Learn More'" @click="showHelp" v-if="showHelpIcon">
          <i class="fa fa-info-circle"></i>
        </a>
        <span v-if="optional" class="pull-right opacity-5 font-italic ml-2">Optional</span>
      </label>
    </slot>

    <span v-if="addonLeftIcon || $slots.addonLeft" class="input-group-addon input-group-prepend">
      <slot name="addonLeft">
        <i :class="addonLeftIcon"></i>
      </slot>
    </span>
    <slot>
      <input
        :value="modelValue"
        @input="updateValue"
        @focus="onFocus"
        @blur="onBlur"
        v-bind="inputAttrs"
        class="bp-form-input bp-u-shadow-04"
        :class="[{valid: modelValue && !error}, inputClasses]"
        aria-describedby="addon-right addon-left">
    </slot>
    <span v-if="addonRightIcon || $slots.addonRight" class="input-group-addon input-group-append">
      <slot name="addonRight">
        <i :class="addonRightIcon"></i>
      </slot>
    </span>

    <slot name="infoBlock"></slot>
    <slot name="helpBlock">
      <div class="text-danger invalid-feedback" style="display: block;" :class="{'mt-2': hasIcon}" v-if="error">
        {{ error }}
      </div>
    </slot>
  </div>
</template>
<script>
import { defineComponent } from 'vue';

export default defineComponent({
  emits: ['update:modelValue', 'focus', 'blur', 'show-help'],
  inheritAttrs: false,
  name: 'fg-input',

  props: {
    required: Boolean,
    optional: Boolean,
    label: String,
    error: String,
    labelClasses: String,
    inputClasses: String,
    modelValue: [String, Number],
    addonRightIcon: String,
    addonLeftIcon: String,
    showHelpIcon: {
      type: Boolean,
      default: true
    }
  },

  data () {
    return {
      touched: false,
      focused: false,
      hadError: false
    }
  },

  computed: {
    hasIcon () {
      const {addonRight, addonLeft} = this.$slots
      return addonRight !== undefined || addonLeft !== undefined || this.addonRightIcon !== undefined || this.addonLeftIcon !== undefined
    },
    inputAttrs () {
      // Forward all $attrs to inner input except class/style (those go to root div)
      const { class: _c, style: _s, ...rest } = this.$attrs
      return rest
    }
  },

  methods: {
    updateValue (evt) {
      let value = evt.target.value
      if (!this.touched && value) {
        this.touched = true
      }
      this.$emit('update:modelValue', value)
    },
    onFocus (value) {
      this.focused = true
      this.$emit('focus', value)
    },
    onBlur (value) {
      this.focused = false
      this.$emit('blur', value)
    },
    showHelp() {
      this.$emit('show-help')
    },
  },

  watch: {
    error (value) {
      if (value) {
        this.hadError = true
      }
    }
  },
});
</script>
<style>
  .input-group.has-right-slot input{
    border-right: 0;
  }

</style>
